import anime from 'animejs/lib/anime.es.js'
import { Default } from './Default.js'
import { Layout } from '@/core/Layout.js'
import { Config } from '@/core/Config.js'

export class Home extends Default {
  init() {
    super.init()

    if (!Layout.inMobileMode && Config.ANIMS_ABOVE_THE_FOLD) {
      this.initHeroAnimation()
    }
  }

  async initHeroAnimation() {
    await this.waitForLcpOrTimeout(4500)
    try {
      const { ensureTheatreProject } = await import('../core/TheatreProject.js')
      await ensureTheatreProject()
      const { HeroHome } = await import('../components/HeroHome.js')
      this.add('.c-hero-bg', HeroHome, this.el, 'HeroHome', true)
    } catch (error) {
      console.warn('Failed to initialize home hero animation:', error)
    }
  }

  animateIn() {
    this.el.style = ''

    const sections = this.getAll('section, .c-section', this.el).slice(0, 2)

    anime({
      targets: sections,
      delay: 100,
      easing: 'easeOutExpo',
      duration: 1000,
      opacity: [0, 1],
    })
  }
}
